export const animationConfig = {
  move: {
    label: "Move",
    defaults: {
      x: 50,
      y: 50,
    },
    fields: [
      {
        key: "x",
        label: "Target X",
        type: "number",
      },
      {
        key: "y",
        label: "Target Y",
        type: "number",
      },
    ],
  },

  fade: {
    label: "Fade",
    defaults: {
      opacity: 1,
    },
    fields: [
      {
        key: "opacity",
        label: "Target Opacity",
        type: "number",
        step: 0.1,
      },
    ],
  },

  scale: {
    label: "Scale",
    defaults: {
      scale: 1,
    },
    fields: [
      {
        key: "scale",
        label: "Target Scale",
        type: "number",
        step: 0.1,
      },
    ],
  },

  rotate: {
    label: "Rotate",
    defaults: {
      rotation: 0,
    },
    fields: [
      {
        key: "rotation",
        label: "Target Rotation (°)",
        type: "number",
      },
    ],
  },
};